"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../utils/constants");
var muiX16 = {
    paths: [
        {
            path: 'M0.266032458,9.58620555 C-0.125713288,9.9779513 -0.126376284,10.6124337 0.259971641,10.9987816 L1.00121842,11.7400284 C1.38961687,12.1284268 2.02733847,12.1204235 2.41379445,11.7339675 L6,8.14776199 L9.58620555,11.7339675 C9.9779513,12.1257133 10.6124337,12.1263763 10.9987816,11.7400284 L11.7400284,10.9987816 C12.1284268,10.6103831 12.1204235,9.97266153 11.7339675,9.58620555 L8.14776199,6 L11.7339675,2.41379445 C12.1257133,2.0220487 12.1263763,1.38756635 11.7400284,1.00121842 L10.9987816,0.259971641 C10.6103831,-0.128426808 9.97266153,-0.120423513 9.58620555,0.266032458 L6,3.85223801 L2.41379445,0.266032458 C2.0220487,-0.125713288 1.38756635,-0.126376284 1.00121842,0.259971641 L0.259971641,1.00121842 C-0.128426808,1.38961687 -0.120423513,2.02733847 0.266032458,2.41379445 L3.85223801,6 L0.266032458,9.58620555 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'X',
    width: 12,
    height: 12,
};
var muiX24 = {
    paths: [
        {
            path: 'M0.327896297,17.8517665 C-0.107805584,18.2874683 -0.108451326,18.9932349 0.330564601,19.4322508 L2.56774916,21.6694354 C3.0049247,22.1066109 3.70748384,22.1128534 4.14823355,21.6721037 L11,14.8203372 L17.8517665,21.6721037 C18.2874683,22.1078056 18.9932349,22.1084513 19.4322508,21.6694354 L21.6694354,19.4322508 C22.1066109,18.9950753 22.1128534,18.2925162 21.6721037,17.8517665 L14.8203372,11 L21.6721037,4.14823355 C22.1078056,3.71253166 22.1084513,3.00676508 21.6694354,2.56774916 L19.4322508,0.330564601 C18.9950753,-0.106610944 18.2925162,-0.112853413 17.8517665,0.327896297 L11,7.17966275 L4.14823355,0.327896297 C3.71253166,-0.107805584 3.00676508,-0.108451326 2.56774916,0.330564601 L0.330564601,2.56774916 C-0.106610944,3.0049247 -0.112853413,3.70748384 0.327896297,4.14823355 L7.17966275,11 L0.327896297,17.8517665 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'X',
    width: 22,
    height: 22,
};
var muiX = {
    base: muiX16,
    smIcon: muiX16,
    lgIcon: muiX24,
};
exports.muiX = muiX;
//# sourceMappingURL=x.js.map